import { useLingui } from '@lingui/react/macro';
import { useEffect } from 'react';
import { ApiError, getErrorReason } from 'shared/errors';

/**
 * Причина отказа запроса уведомлений для экрана: переведённая фраза из реестра `shared/errors` по коду
 * ошибки или, если код не распознан, общая «Произошла ошибка при загрузке уведомлений». Сырой текст
 * Supabase — английский и технический — на экран не попадает: он уходит в `console.error`.
 *
 * `undefined`, пока ошибки нет.
 */
export function useNotificationsErrorReason(error: ApiError | null): string | undefined {
  const { t, i18n } = useLingui();

  useEffect(() => {
    if (error) console.error('Не удалось загрузить уведомления:', error);
  }, [error]);

  if (!error) return undefined;

  const reason = getErrorReason(error);
  return reason ? i18n._(reason) : t`Произошла ошибка при загрузке уведомлений`;
}
